import React, { Component } from 'react'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom'
import { Notification, Alert } from './'
import { NotificationStyle } from './../styles'

class Notifications extends Component {
  state = {
    open: false,
    seen: false,
    number: 0,
  }

  componentDidMount() {
    this.checkSeen()
  }

  componentWillReceiveProps({page_seen}) {
    if (page_seen !== this.props.page_seen) {
      this.checkSeen()
    }
  }

  checkSeen = () => {
    this.props.notifications.map((notification) => {
      if (!notification.page_seen) this.setState({ seen: true })
      return notification.page_seen
    })

    this.setState({
      number : this.props.notifications.filter((notification) => !notification.page_seen).length
    })
  }

  controlPanel = () => {
    this.props.callbackClick()
  }

  handleSeen = (e) => {
    if (e.currentTarget.classList.contains('hightlight')) {
      e.currentTarget.classList.remove('hightlight')
      this.setState({
        number: this.state.number - 1,
        seen: this.state.number - 1 > 0 ? true : false, 
      })
    }
  }
  
  render() {
    const { open, notifications } = this.props
    const { seen, number } = this.state
    return (
      <div ref={(el) => this.notification = el} className="notification">
        <button type="button" className={`btn btn--icon ${open ? 'open': ''}`} onClick={this.controlPanel}>
          <Notification width={24} height={24} />
          {
            seen ? <span className='dot'> {number} </span> : ''
          }
        </button>
        {
          notifications.length > 0 && (
            <div className={`${ NotificationStyle(open) } notification-panel`}>
              {
                notifications.map((notification, index) => (
                  <div className={`notification-line ${!notification.page_seen && 'hightlight' } ${notification.type === 'alert' && 'alert'}`} key={index} onClick={this.handleSeen}>
                    <Link to={notification.link}>
                      <span className="icon">
                        {
                          notification.type === 'alert' ? <Alert width={18} height={18} /> : <Notification width={18} height={18} />
                        }
                      </span>
                      <span className="label">{notification.name}</span>
                    </Link>
                  </div>
                ))
              }
            </div>
          )
        }
      </div>
    )
  }
}

export default connect(
  state => ({
    notifications: state.Session.notifications
  }),
)(Notifications)


// WEBPACK FOOTER //
// ./src/components/Notifications.js